import { prepareRissAttachments } from './rissAttachments.mjs'
import { validateRissJpegBase64 } from './rissJpeg.mjs'

function asBase64(bytes) {
  let binary = ''
  for (let index = 0; index < bytes.length; index += 8192) {
    binary += String.fromCharCode(...bytes.subarray(index, index + 8192))
  }
  return btoa(binary)
}

/** No networking or image decoder is embedded here. Both are injected. */
export async function prepareRissXmlImages(transactions, downloadBlob, convertToJpeg) {
  if (typeof downloadBlob !== 'function' || typeof convertToJpeg !== 'function') {
    throw new Error('Photo preparation requires a downloader and JPEG converter.')
  }
  const attachments = await prepareRissAttachments(transactions, downloadBlob)
  const encoded = new Map()
  let totalBytes = 0
  for (const file of attachments.files) {
    const bytes = await convertToJpeg(file.bytes)
    if (!(bytes instanceof Uint8Array) || bytes.length > 2 * 1024 * 1024) {
      throw new Error('A prepared report photo exceeds the JPEG size limit.')
    }
    totalBytes += bytes.length
    if (totalBytes > 50 * 1024 * 1024) throw new Error('Prepared photos exceed 50 MB. Select fewer purchases.')
    const base64 = asBase64(bytes)
    if (!validateRissJpegBase64(base64).valid) {
      throw new Error('Report photos must be valid 640 × 480 JPEG images.')
    }
    encoded.set(file.name, base64)
  }
  const images = Object.create(null)
  for (const [transactionId, filenames] of Object.entries(attachments.attachmentFilenames)) {
    images[transactionId] = {
      item: Object.fromEntries(Object.entries(filenames.item).map(([index, name]) => [index, encoded.get(name)])),
      ...(filenames.customerId ? { customerId: encoded.get(filenames.customerId) } : {}),
      ...(filenames.customer ? { customer: encoded.get(filenames.customer) } : {}),
    }
  }
  return { images, imageCount: attachments.files.length, warnings: attachments.warnings }
}
